module.exports = __webpack_public_path__ + "img/toggle-sidebar-left.ec15136e.svg";